import { createFileRoute } from '@tanstack/react-router';

import { PdfItemView } from '#/features/community-hub/components/block-viewers/pdf-item-view';

/**
 * PDF item viewer. Path: /programs/{program}/{module}/{lesson}/pdf/{itemSlug}
 */
export const Route = createFileRoute('/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/pdf/$itemSlug')({
  component: PdfContentRoute,
});

function PdfContentRoute() {
  const { itemSlug } = Route.useParams();
  // Keyed so opening another item remounts the view instead of keeping the last item's state.
  return <PdfItemView key={itemSlug} itemSlug={itemSlug} />;
}
